import styled from "@emotion/styled"
import { HiDotsCircleHorizontal } from "react-icons/hi"

export interface StylesProps {
  isOpen?: boolean
  numberOfVisibleElements?: number
}

export const Container = styled.div`
  position: relative;
`

export const ContainerIcons = styled.div<StylesProps>`
  display: flex;
  width: ${props =>
    props.isOpen
      ? `calc(${
          props.numberOfVisibleElements *
          (props.numberOfVisibleElements > 3
            ? 2.73
            : props.numberOfVisibleElements < 3
            ? 3.2
            : 2.8)
        }rem + 1.35rem)`
      : "0rem"};
  background: rgba(255, 255, 255, 0.4);
  position: absolute;
  bottom: 0rem;
  right: 0rem;
  transition: 0.5s;
  border-radius: 1rem;
  padding: ${props => props.isOpen && `0rem 0.5rem 0rem 0rem`};
`

export const WrapperIcons = styled.div<StylesProps>`
  display: flex;
  transition: ${props => (props.isOpen ? "opacity 0.6s" : "opacity 0.2s")};
  opacity: ${props => (props.isOpen ? "1" : "0")};
`

export const ToggleIcon = styled(HiDotsCircleHorizontal)`
  font-size: 1.9rem;
  color: rgba(0, 0, 0, 0.2);
  stroke: white;
  stroke-width: 1.5px;
`
